import { render } from "./businessConfig.vue?vue&type=template&id=a45bdcea&scoped=true"
import script from "./businessConfig.vue?vue&type=script&lang=js"
export * from "./businessConfig.vue?vue&type=script&lang=js"

import "./businessConfig.vue?vue&type=style&index=0&id=a45bdcea&lang=less&scoped=true"

import exportComponent from "E:\\MySite\\XuDAQMS\\xudaqms-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a45bdcea"]])

export default __exports__